import { FC, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import CollectionTable from "./CollectionTable";
import EditCollection from "./EditCollection";

const Collection: FC = () => {
  const [searchParams] = useSearchParams();
  const [showCreateForm, setShowCreateForm] = useState(false);
  
  // Check for iframe mode with create mode
  useEffect(() => {
    const isIframeMode = searchParams.get('iframe') === 'true';
    const isCreateMode = searchParams.get('mode') === 'create';
    
    if (isIframeMode && isCreateMode) {
      setShowCreateForm(true);
    }
  }, [searchParams]);

  // If in iframe create mode, show only the EditCollection component
  if (showCreateForm) {
    return (
      <div style={{ padding: '20px', height: '100vh', overflow: 'auto' }}>
        <EditCollection
          editItem={{}}
          mode="create"
          onCloseEdit={() => {
            setShowCreateForm(false);
            // Optionally close the iframe or redirect
            if (window.parent !== window) {
              // We're in an iframe, send message to parent
              window.parent.postMessage({ type: 'close-modal' }, '*');
            }
          }}
        />
      </div>
    );
  }

  return <CollectionTable />;
};

export default Collection;
